import React from 'react';

import { BareSailingDay } from '@go-shared/types/sailing';
import { isoDate } from '@go-shared/lib/time';
import { getDayLocation } from '@go-shared/lib/sailing';

interface ReportsGridHeaderProps {
  sailingDay: BareSailingDay;
}
export const ReportsGridHeader = ({ sailingDay }: ReportsGridHeaderProps) => {
  return (
    <div className="pr-5 pl-5">
      <div className="inline-flex items-baseline mr-5">
        <h3 className="text-grey-dark mr-2">Date:</h3>
        <h2 className="text-teal-darker">{isoDate(sailingDay.date)}</h2>
      </div>
      <div className="inline-flex items-baseline mr-5">
        <h3 className="text-grey-dark mr-2">Day:</h3>
        <h2 className="text-teal-darker">{sailingDay.name}</h2>
      </div>
      <div className="inline-flex items-baseline">
        <h3 className="text-grey-dark mr-2">Location:</h3>
        <h2 className="text-teal-darker">{getDayLocation(sailingDay)}</h2>
      </div>
    </div>
  );
};
